import React from 'react'
import './posts.css'
import Post from '../post/Post'
import PostSkeleton from '../post/PostSkeleton'
import {Link} from 'react-router-dom'

function Posts({posts, loading, searchTerm}) {
    return (
        <div className="posts">
          
            { 
            
            loading ? <><PostSkeleton/><PostSkeleton/><PostSkeleton/><PostSkeleton/><PostSkeleton/></>
            :
                posts.filter((post) => {
                    if(searchTerm === ""){
                      return post
                    }else if(post.title.toLowerCase().includes(searchTerm.toLowerCase())){
                      return post
                    }
                    
                  })
                  .map(post => (
                    <Link key={post._id} to={`/posts/${post._id}`}>
                      <Post  loading={loading} post={post} />
                    </Link>
                ))              
            }
        </div>
    )
}

export default Posts
